'use client'

;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { CalendlyPlainButton } from '@/components/integrations/calendly/calendly-buttons'
import { ButtonLink } from '@/components/ui/button'
import { getPagePath, type Locale } from '@/i18n/routing'
import { trackCta } from '@/lib/analytics/track-cta'

export function PrimaryCtaButtons({
  locale,
  startTrialLabel,
  bookDemoLabel,
  light = false,
  location = 'primary-cta',
}: {
  locale: Locale
  startTrialLabel: string
  bookDemoLabel: string
  light?: boolean
  location?: string
}) {
  const buttonColor = light ? 'light' : undefined
  const plainColor = light ? 'light' : 'dark/light'

  // Side by side wherever they fit, one under the other where they do not: at 320px the second
  // button used to run off the hero card and be clipped by it.
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-3">
      <ButtonLink
        href={getPagePath(locale, 'signup')}
        color={buttonColor}
        onClick={() => trackCta(location, startTrialLabel)}
      >
        {startTrialLabel}
      </ButtonLink>
      <CalendlyPlainButton label={bookDemoLabel} color={plainColor} location={location} />
    </div>
  )
}
